import React, { useState, useEffect } from 'react';
import './Gallery.css';
import { API_BASE_URL } from '../config';

interface GalleryImage {
  id: number;
  image: string | null;
  alt_text: string;
  order: number;
  created_at: string;
}

interface GalleryData {
  id: number;
  header: string;
  description: string;
  images: GalleryImage[];
  created_at: string;
  updated_at: string;
}

const Gallery: React.FC = () => {
  const [galleryData, setGalleryData] = useState<GalleryData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = 'Photos | Patates | Guesthouse in Martuni';
  }, []);

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/gallery/`);
        if (!response.ok) {
          throw new Error('Failed to fetch gallery data');
        }
        const data = await response.json();
        setGalleryData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchGalleryData();
  }, []);

  if (loading) {
    return (
      <div className="gallery-page">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Loading gallery...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="gallery-page">
        <div className="error">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-page">
      {/* Hero Section */}
      <section className="gallery-hero">
        <div className="container">
          <h1>Gallery</h1>
          <p>Take a virtual tour of Patates Guesthouse</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-section">
        <div className="container">
          <div className="gallery-grid">
            {galleryData?.images && galleryData.images.length > 0 ? (
              galleryData.images
                .sort((a, b) => a.order - b.order)
                .map((image) => (
                  <div key={image.id} className="gallery-item">
                    <div className="item-image">
                      {image.image ? (
                        <img 
                          src={image.image} 
                          alt={image.alt_text || `Gallery Image ${image.id}`}
                          className="gallery-image"
                        />
                      ) : (
                        <div className="image-placeholder">🖼️</div>
                      )}
                    </div>
                    <div className="item-overlay">
                      <h3>{image.alt_text || `Image ${image.id}`}</h3>
                    </div>
                  </div>
                ))
            ) : (
              <div className="no-images">
                <p>No gallery images available</p>
              </div>
            )}
          </div>
        </div>
      </section>




    </div>
  );
};

export default Gallery; 